import { defineComponent, ref } from 'vue'
import { useField, useForm } from 'vee-validate'
import ru from 'yup-locale-ru'
import { host } from '@/const'
import axios from '@/axios'
import * as yup from 'yup'
import Select from '@/components/select'
import Preloader from '@/components/preloader/preloader.vue'
import './style.sass'

export default defineComponent({
  props: {
    closeUploadFile: {
      type: Function,
      required: true
    },
    isSuccessUpload: {
      type: Function,
      required: true
    },
    typeFiles: {
      type: String,
      default: () => 'orders'
    },
    orders: {
      type: Array,
      default: () => []
    },
    companies: {
      type: Array,
      default: () => []
    },
    messageError: {
      type: String,
      default: () => 'Обязательно для заполнения'
    }
  },
  setup (props) {
    yup.setLocale(ru)

    const preloader = ref(false)
    const errorResponse = ref('')
    const successResponse = ref(false)

    const endpoint = ref('/api/v1/client/files/create')
    const FILE_SIZE = 15 * 1000 // 15 мегабайт в байтах
    const uploadFilePercentage = ref(0)
    const SUPPORTED_FORMATS = [
      'image/jpg',
      'image/jpeg',
      'image/png',
      'application/pdf'
    ]

    const schema = yup.object().shape(
      {
        ownerId: yup.string().required(props.messageError),
        file: yup.mixed()
          .test(
            'fileSize',
            'Файл слишком большой',
            value => {
              return value && value.size > FILE_SIZE
            }
          )
          .test(
            'fileFormat',
            'Этот формат не поддерживается',
            value => {
              errorResponse.value = ''
              if (value && SUPPORTED_FORMATS.includes(value.type)) {
                return true
              } else {
                uploadFilePercentage.value = 0
                preloader.value = false
                return false
              }
            }
          )
          .required()
      }
    )

    type FormInputs = {
      ownerId: string
      file: File | string
    }

    const { handleSubmit } = useForm<FormInputs>({ validationSchema: schema })

    const onSubmit = handleSubmit(async (values) => {
      preloader.value = true
      let ownerType = 'clientDocuments'
      if (props.typeFiles === 'company') {
        ownerType = 'clientCompanyDocuments'
      } else if (props.typeFiles === 'orders') {
        ownerType = 'order'
      }

      if (uploadFilePercentage.value === 0) {
        preloader.value = true
        const formData: FormData = new FormData()
        formData.append('file', file.value)
        formData.append('ownerType', ownerType)
        if (ownerId.value !== 'client' && ownerId.value !== '') {
          formData.append('ownerId', ownerId.value)
        }
        uploadFilePercentage.value = 1

        axios.post(`${host}${endpoint.value}`, formData)
          .then(json => {
            if (json.status === 200 || json.status === 201) {
              successResponse.value = true
              uploadFilePercentage.value = 0
              props.isSuccessUpload()
              if (props.typeFiles === 'person') {
                ownerId.value = 'client'
              } else {
                ownerId.value = ''
              }
            }
            preloader.value = false
          })
          .catch(e => {
            fileError.value = ''
            errorResponse.value = 'Ошибка запроса, попробуйте повторить позже'
            uploadFilePercentage.value = 0
          })
          .finally(() => {
            preloader.value = false
            uploadFilePercentage.value = 100
          })
      }
    })

    const { value: ownerId, errorMessage: ownerIdError } = useField<string>('ownerId')
    const { value: file, errorMessage: fileError } = useField<File>('file')

    if (props.typeFiles === 'person') {
      ownerId.value = 'client'
    }

    function selectFile ($event: any) {
      file.value = $event.target.files[0] as File
      uploadFilePercentage.value = 0
    }

    function dropHandler ($event: DragEvent) {
      file.value = $event.dataTransfer!.files[0] as File
      uploadFilePercentage.value = 0
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      $event.currentTarget.classList.remove('drag-leave')
      $event.preventDefault()
    }

    function dragoverHandler ($event: DragEvent) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!$event.currentTarget.classList.contains('drag-leave')) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        $event.currentTarget.classList.add('drag-leave')
      }
      $event.preventDefault()
    }

    function dragleaveHandler ($event: DragEvent) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      $event.currentTarget.classList.remove('drag-leave')
    }

    function selectOwner (e: any) {
      ownerId.value = e.value
    }

    function selectFirst (values: any[] | undefined) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (values.length > 0) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return values[0].title
      } else {
        return ''
      }
    }

    function closeModal ($event: MouseEvent) {
      // @ts-ignore
      if ($event?.target?.classList.value === 'close' || $event?.target?.classList.value === 'overlay') {
        props.closeUploadFile()
      }
    }

    return () => (
      <div class="overlay" onClick={($event) => closeModal($event)}>
        <div class="modal">
          <a class="close" onClick={($event) => closeModal($event)}/>
          <p>Загрузить документ</p>
          {successResponse.value === true
            ? (
              <div class="success-block">
                <div class="success-icon" />
                <p>Файл успешно сохранён!</p>
              </div>
            )
            : (
              <form onSubmit={values => onSubmit(values)} >
                {props.typeFiles === 'company'
                  ? (<div class="filters">
                    <Select
                      class="filters-select"
                      options={props.companies}
                      value={selectFirst(props.companies)}
                      onSelectChange={(e: any) => {
                        selectOwner(e)
                      }}
                    />
                    {ownerIdError.value
                      ? (<span class="error-message" style="text-align: left;">{ownerIdError.value}</span>)
                      : null
                    }
                  </div>)
                  : null
                }
                {props.typeFiles === 'orders'
                  ? (<div class="filters">
                    <Select
                      class="filters-select"
                      options={props.orders}
                      value={selectFirst(props.orders)}
                      onSelectChange={(e: any) => {
                        selectOwner(e)
                      }}
                    />
                    {ownerIdError.value
                      ? (<span class="error-message" style="text-align: left;">{ownerIdError.value}</span>)
                      : null
                    }
                  </div>)
                  : null
                }
                <div
                  class="document-block"
                  onDrop={($event) => dropHandler($event)}
                  onDragover={($event) => dragoverHandler($event)}
                  onDragleave={($event) => dragleaveHandler($event)}
                >
                  <div class="document">
                    <span style="margin-top: 20px;">Выберите файл, или перенесите его сюда</span>
                    <input
                      type="file"
                      id="document"
                      name="document"
                      onChange={($event) => selectFile($event)}
                    />
                    {preloader.value && uploadFilePercentage.value < 100
                      ? (<Preloader style="position: relative; margin: 30px auto; top: -10px;"/>)
                      : (
                        <label for="document" class="file-upload">
                          Выбрать файл
                        </label>
                      )
                    }
                    {uploadFilePercentage.value > 0 && !errorResponse.value
                      ? (
                        <div class="progress-file">
                          <div class="pregress-bar">
                            <div class="custom-progress" style={`width:${uploadFilePercentage.value}%`}></div>
                            <progress max="100"></progress>
                          </div>
                          <span>{uploadFilePercentage.value}%</span>
                        </div>
                      )
                      : null
                    }
                    {file.value && !fileError.value && !errorResponse.value
                      ? (<span class="file-upload-path">{'name' in file.value ? file.value.name : ''}</span>)
                      : null
                    }
                    {fileError.value
                      ? (<span class="error-message">{fileError.value}</span>)
                      : null
                    }
                    {errorResponse.value
                      ? (<span class="error-message">{errorResponse.value}</span>)
                      : null
                    }
                    <span style={!fileError.value && !file.value ? 'margin-top:30px;' : ''}>JPEG, PNG, PDF - не более 15MB</span>
                  </div>
                </div>
                {preloader.value && uploadFilePercentage.value === 100
                  ? (<Preloader style="position: relative; margin: 50px auto; top: -10px;"/>)
                  : (<button disabled={errorResponse.value !== '' || preloader.value}>Подтвердить</button>)
                }
              </form>
            )
          }
        </div>
      </div>
    )
  }
})